import { CircleHelp } from 'lucide-react';
import {
  Tooltip as UITooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

// Matches the tooltip style used in Stats.tsx (CircleHelp icon, default
// TooltipContent styling, no size/opacity overrides).
//   <InfoTooltip text="What this metric means." />
export function InfoTooltip({ text }) {
  return (
    <TooltipProvider>
      <UITooltip>
        <TooltipTrigger asChild>
          <CircleHelp className="h-5 w-5 text-muted-foreground no-export" />
        </TooltipTrigger>
        <TooltipContent>
          <p>{text}</p>
        </TooltipContent>
      </UITooltip>
    </TooltipProvider>
  );
}